<template>
  <div
    class="f-col gap-4 pointer-within items-center md:flex-row md:wrap"
    :class="[equalTargetSizeClass]"
    :style="`--cols: repeat(${targets.length},minmax(0,1fr))`"
  >
    <cms-shared-button v-for="(target, i) in targets" :key="i" v-bind="{ ...target, ...textLinkStyle }" :size />
  </div>
</template>

<script setup lang="ts">
import type { Responsive } from '#types/common'
import type { TextLinkStyle } from '#types/styles'
import type { Target } from '#types/target'

const props = defineProps<{
  targets: Target[]
  textLinkStyle: TextLinkStyle
  equalTargetSize: Responsive<boolean>
}>()

const { size } = useAppConfig().components.cms.sharedButton

const equalTargetSizeClass = props.targets.length > 1 && {
  '<md:grid <md:auto-rows-fr <md:items-stretch': getValueForBreakpoint('sm', props.equalTargetSize),
  'md:grid md:auto-rows-fr md:items-stretch': getValueForBreakpoint('md', props.equalTargetSize),
  'lg:grid lg:auto-rows-fr lg:items-stretch': getValueForBreakpoint('lg', props.equalTargetSize)
}
</script>
